import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_tai_chi_walking_f_btn_color~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_tai_chi_walking_f_btn_color/__b'),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_tai_chi_walking_f_btn_color~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_tai_chi_walking_f_btn_color/__b'),
			},
		},
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_tai_chi_walking_f_btn_color~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_tai_chi_walking_f_btn_color/__b'),
			},
		},
	},
	{
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_tai_chi_walking_f_btn_color~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_tai_chi_walking_f_btn_color/__c'),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_tai_chi_walking_f_btn_color~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_tai_chi_walking_f_btn_color/__c'),
			},
		},
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_tai_chi_walking_f_btn_color~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_tai_chi_walking_f_btn_color/__c'),
			},
		},
	},
	{
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_tai_chi_walking_f_btn_color~3
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_tai_chi_walking_f_btn_color/__d'),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_tai_chi_walking_f_btn_color~3
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_tai_chi_walking_f_btn_color/__d'),
			},
		},
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_tai_chi_walking_f_btn_color~3
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_tai_chi_walking_f_btn_color/__d'),
			},
		},
	},
]

export default config
